<template>
  <v-container fluid>
    <v-card class="my-5 elevation-0" height="100%">
      <v-card-title>
        <v-btn text small @click="$router.back()">
          <v-icon left> mdi-arrow-left </v-icon>
          Back
        </v-btn>
        <v-spacer />
        <v-btn small color="primary" @click="downloadLink(document)">
          <v-icon left> mdi-download </v-icon>
          Download
        </v-btn>
      </v-card-title>
      <v-divider />

      <v-row>
        <v-col cols="8" offset="2">
          <v-card-text class="elevation-1 my-1">
            <pdf style="width: 100%" :src="document" />
          </v-card-text>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
import pdf from "vue-pdf";
import FileMixin from "../../dashboard/mixin/FileMixin";

export default {
  name: "ExemptionReceipt",
  mixins: [FileMixin],
  components: { pdf },
  beforeRouteEnter(to, from, next) {
    next((v) => {
      v.$store.dispatch("Exemption/getExemptionReceipt", v.$route.params.code);
    });
  },
  computed: {
    document() {
      return this.$store.getters["Exemption/exemptionGetter"]("receipt");
    },
  },
  methods: {},
};
</script>
